<div id="dropdownWrapper">
  <p>GBP location group</p>
  <mat-form-field appearance="fill" class="headerCellInput">
    <mat-select [formControl]="selectedGrp" panelClass="ccDropdownPanels">
      @for (grp of getGbpGroups(); track grp) {
        @if (grp.accountName) {
          <mat-option [value]="grp">
            {{ grp.accountName }}
          </mat-option>
        }
      }
    </mat-select>
  </mat-form-field>

  <button mat-icon-button
    [matMenuTriggerFor]="infoMenu"
    [ngClass]="{infoMenuOpened: infoMenuOpened}"
    (menuOpened)="onInfoMenuOpened()">
    <mat-icon svgIcon="help_outline"></mat-icon>
  </button>
</div>

<mat-menu #infoMenu="matMenu"
  yPosition="below"
  (closed)="onInfoMenuClosed()"
  class="infoMenu">
  This is the location group where new locations will be created in (this currently affects create,
  claim and duplicate actions). It is advantageous if that location group is owned by a bulk
  verified Google account.
</mat-menu>
